import Layout from '@/layout/index.vue';
// import RouterView from '@/layout/routerView';
import { createCustomComponent } from '@/utils/index';

/**
 * 路由meta对象参数说明
 * meta: {
 *    title           string，菜单栏及 tagsView 栏名称
 *    isHide：        boolean，菜单栏是否隐藏此路由
 *    roles：         string[]，当前路由权限标识，取用户角色，控制路由显示、隐藏。系统角色：0管理员 1普通用户 2超级管理员
 *    deptTypes       number[]，当前用户单位类型，控制路由显示、隐藏。系统单位类型：1公园 2林场 3园林绿化大数据中心
 *    keepAlive      string[]，当cacheNames包含要跳转的页面name时，当前页需要被缓存
 *    showBreadcrumb  boolean，是否显示当前页面的路径
 *    icon            string，菜单图标
 *    svgClass        string，icon为svg时的样式类
 *    indent          number，菜单缩进，单位px
 * }
 */
// 动态路由
export const dynamicRoutes = [
  {
    path: '/',
    name: 'home',
    component: Layout,
    redirect: '/console',
    children: [
      {
        path: '/console',
        name: 'Console',
        component: () => import('@/views/console/index.vue'),
        meta: {
          title: '控制台',
          roles: [],
          deptTypes: [3],
          isHide: false,
          icon: 'menu-console',
        },
      },
      {
        path: '/device/monitor',
        name: 'MonitorDevice',
        component: () => import('@/views/device/index.vue'),
        meta: {
          title: '监控设备',
          roles: [],
          deptTypes: [1, 3],
          isHide: false,
          icon: 'menu-jk',
        },
      },
      // {
      //   path: '/device/channel/:deviceId/:channelParentId',
      //   name: 'DeviceChannel',
      //   component: () => import('@/views/device/monitor/channel.vue'),
      //   meta: {
      //     title: '设备通道列表',
      //     roles: [],
      //     isHide: true,
      //     showBreadcrumb: true,
      //   },
      // },
      // {
      //   path: '/map',
      //   name: 'Map',
      //   component: () => import('@/views/map/index.vue'),
      //   meta: {
      //     title: '电子地图',
      //     roles: [],
      //     isHide: true,
      //     icon: 'menu-console',
      //   },
      // },
      {
        path: '/videoLive',
        name: 'VideoLive',
        component: () => import('@/views/videoLive/index.vue'),
        meta: {
          title: '监控视频',
          roles: [],
          deptTypes: [1, 3],
          isHide: false,
          icon: 'menu-video',
        },
      },
      {
        path: '/infrared',
        name: 'Infrared',
        redirect: '/infrared/overview',
        meta: {
          title: '红外相机',
          roles: [],
          deptTypes: [2, 3],
          isHide: false,
          icon: 'menu-hw',
        },
        children: [
          {
            path: '/infrared/overview',
            name: 'InfraredOverview',
            component: () => import('@/views/infrared/overview.vue'),
            meta: {
              title: '相机总览',
              roles: [],
              deptTypes: [2, 3],
              isHide: false,
              showBreadcrumb: false,
              icon: 'el-icon-s-help',
            },
          },
          {
            path: '/infrared/real',
            name: 'Infrared2',
            component: createCustomComponent('Infrared2', () => import('@/views/infrared/index.vue')),
            meta: {
              title: '实时相机',
              roles: [],
              deptTypes: [2, 3],
              isHide: false,
              showBreadcrumb: false,
              icon: 'hw-real',
              svgClass: 'font18',
              indent: 40,
              keepAlive: ['InfraredDetail'],
            },
          },
          {
            path: '/infrared/normal',
            name: 'Infrared1',
            component: createCustomComponent('Infrared1', () => import('@/views/infrared/index.vue'), ),
            meta: {
              title: '普通相机',
              roles: [],
              deptTypes: [2, 3],
              isHide: false,
              showBreadcrumb: false,
              icon: 'hw-normal',
              indent: 40,
              keepAlive: ['InfraredDetail'],
            },
          },
          {
            path: '/infrared/detail',
            name: 'InfraredDetail',
            component: () => import('@/views/infrared/detail.vue'),
            meta: {
              title: '相机详情',
              roles: [],
              deptTypes: [2, 3],
              isHide: true,
              showBreadcrumb: true,
              breadcrumbs: [
                { title: '红外相机' },
                { title: '相机详情' },
              ],
              icon: '',
            },
          },
          {
            path: '/infrared/image',
            name: 'InfraredImage',
            redirect: '/infraredCamera/image/checked',
            meta: {
              title: '相机图像',
              roles: [],
              deptTypes: [2, 3],
              isHide: false,
              icon: 'menu-xjtx',
            },
            children: [
              {
                path: '/infrared/image/notIdentity',
                name: 'InfraredImage0',
                component: () => import('@/views/infrared/cameraImage.vue'),
                props: {
                  identStatus: '0',
                },
                meta: {
                  title: '未鉴定',
                  roles: [],
                  deptTypes: [2, 3],
                  isHide: false,
                  icon: 'menu-xjtx-wjd',
                },
              },
              {
                path: '/infrared/image/identified',
                name: 'InfraredImage1',
                component: () => import('@/views/infrared/cameraImage.vue'),
                props: {
                  identStatus: '1',
                },
                meta: {
                  title: '已鉴定',
                  roles: [],
                  deptTypes: [2, 3],
                  isHide: false,
                  icon: 'menu-xjtx-yjd',
                },
              },
            ],
          },
          {
            path: '/infrared/identifyResultStat',
            name: 'InfraredIdentifyResultStat',
            component: () => import('@/views/infrared/identifyResultStat.vue'),
            meta: {
              title: '发现结果',
              roles: [],
              deptTypes: [2, 3],
              isHide: false,
              icon: 'menu-fxjg',
              keepAlive: ['InfraredIdentifySpecie'],
            },
          },
          {
            path: '/infrared/identifySpecie',
            name: 'InfraredIdentifySpecie',
            component: () => import('@/views/infrared/identifySpecie.vue'),
            meta: {
              title: '发现物种',
              roles: [],
              deptTypes: [2, 3],
              isHide: true,
              icon: '',
              showBreadcrumb: true,
              breadcrumbs: [
                { title: '红外相机' },
                { title: '发现结果' },
                { title: '物种' },
              ],
            },
          },
        ],
      },
      {
        path: '/platform',
        name: 'Platform',
        redirect: '/platform/child',
        meta: {
          title: '级联管理',
          roles: ['2'],  // 仅超级管理员拥有该权限
          isHide: false,
          icon: 'menu-jl',
        },
        children: [
          {
            path: '/platform/child',
            name: 'ChildPlatform',
            component: () => import('@/views/platform/child/index.vue'),
            meta: {
              title: '下级平台/设备',
              roles: ['2'],
              isHide: false,
              icon: 'menu-jl-child',
              keepAlive: ['ChildPlatformChannel'],
            },
          },
          {
            path: '/platform/child/channel',
            name: 'ChildPlatformChannel',
            component: () => import('@/views/platform/child/channel.vue'),
            meta: {
              title: '下级平台通道列表',
              roles: ['2'],
              isHide: true,
              showBreadcrumb: true,
              breadcrumbs: [
                { title: '级联管理' },
                { title: '下级平台通道' },
              ],
            },
          },
          {
            path: '/platform/parent',
            name: 'ParentPlatform',
            component: () => import('@/views/platform/parent/index.vue'),
            meta: {
              title: '上级平台',
              roles: ['2'],
              isHide: false,
              icon: 'menu-jl-parent',
            },
          },
        ],
      },
      // {
      //   path: '/streamProxy',
      //   name: 'StreamProxy',
      //   component: () => import('@/views/streamProxy/index.vue'),
      //   meta: {
      //     title: '拉流代理',
      //     roles: [],
      //     isHide: false,
      //   },
      // },
      {
        path: '/userManager',
        name: 'UserManager',
        component: () => import('@/views/userManager/index.vue'),
        meta: {
          title: '用户管理',
          roles: ['0', '2'],
          isHide: false,
          icon: 'menu-user',
        },
      },
      {
        path: '/operationLog',
        name: 'OperationLog',
        component: () => import('@/views/operationLog/index.vue'),
        meta: {
          title: '操作日志',
          roles: ['0', '2'],
          isHide: true,
          icon: ''
        },
      },
      
    ],
  },
];

// 静态路由
export const staticRoutes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/login/index.vue'),
    meta: {
      title: '登录',
    },
  },
  // 系统帮助文档
  {
    path: '/md/:path+',
    name: 'HelpDocument',
    component: () => import('@/views/helpDocument/index.vue'),
    meta: {
      title: '系统帮助文档',
    },
  },
  {
    path: '/404',
    name: 'notFound',
    component: () => import('@/components/errorPage/404.vue'),
    meta: {
      title: '没有找到此页面',
    },
  },
  {
    path: '/401',
    name: 'notAuth',
    component: () => import('@/components/errorPage/401.vue'),
    meta: {
      title: '没有权限',
    },
  },
  // 匹配所有未匹配到的路由，注意：要放在路由配置的末尾，以确保它不会影响其他路由的匹配
  // {
  //   path: '/:path(.*)*',
  //   redirect: '/404',
  // },
];



// WEBPACK FOOTER //
// ./src/router/routerConfig.js